import type { DigitalWorkerDetail } from '@/frontend/pages/Dashboard/DigitalWorkers/types'

// Gate compartilhado do chat (SZ-1583): "pronto para conversar" = instância
// `ready` + bridge de chat (`probe_connect_ready`). Quando não está pronto,
// devolve o MOTIVO nomeado (provisionando / falha / sem gateway) para a UI
// explicar in-place em vez de trancar. Extraído do antigo
// StartConversationComposer (Ajuste D removeu o composer da Visão geral) para
// que a aba Chat do portal (Ajustes B/C) reuse a mesma semântica testada.

export function chatUnavailableReason(worker: DigitalWorkerDetail): string | null {
  const name = worker.name.trim() || 'seu colaborador digital'
  if (worker.provisioning_status === 'ready') {
    if (worker.probe_connect_ready) return null
    return `O chat de ${name} ainda não está disponível — a instância ainda não tem conexão de chat configurada.`
  }
  if (worker.provisioning_status === 'failed' || worker.provisioning_stale) {
    return `A instância de ${name} está indisponível no momento — o chat depende dela para funcionar.`
  }
  return `A instância de ${name} ainda está sendo preparada — o chat abre assim que ela ficar pronta.`
}
